export default __webpack_public_path__ + "static/media/bunch-of-coins.2f232019.svg";